import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ecm-mat-seo-reasons',
    templateUrl: 'material-seo-reasons.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf],
})
export class MaterialSeoReasonsComponent {
    @Input() public title?: string;
    @Input() public subTitle?: string;
    @Input({ required: true }) public items: string[];
    @Input() public caption?: string;
    @Input() public e2e = 'e2e-mat-seo-reasons';
}
